import React, {useContext, useEffect, useState} from 'react'
import GeneralInfoExpansionPanelTitle from "./GeneralInfoExpansionPanelTitle";
import Tr from "translations/Translations";
import ExpansionPanel from "components/ExpansionPanel";
import DemandOffersGeneralInfoService from "services/DemandOffersGeneralInfoService";
import {withRouter} from "react-router";
import {connect} from "react-redux";
import Loading from "components/Loading";
import GeneralInfoDocumentsFileTable from "./GeneralInfoDocumentsFileTable";
import PurchaserOfferContext from "context/PurchaserOfferContext";
import DemandOffersService from "services/DemandOffersService";
import {StageSections} from "../../../../constants/StageSections";

function GeneralInfoDocuments(
    {
        match,
        panelsClassesObject,
        generalInfoDocuments,
        demandStageSectionsList
    }) {
    const [expanded, setExpanded] = useState(false);
    const demandId = match.params.id;
    const stageId = match.params.stageId;
    const purchaserOfferContext = useContext(PurchaserOfferContext);
    const unreadDemandDocuments = demandStageSectionsList[StageSections.GENERAL_INFO].unreadDemandDocuments;
    useEffect(() => {
        if (expanded && generalInfoDocuments === undefined)
            DemandOffersGeneralInfoService.getContractorGeneralInfoDocuments(demandId, stageId, purchaserOfferContext?.supplierId);
        return () => {
            DemandOffersGeneralInfoService.clearResources(DemandOffersGeneralInfoService.GENERAL_INFO_DOCUMENTS);
        }
        // eslint-disable-next-line
    }, [expanded])


    return (
        <ExpansionPanel
            classesObj={panelsClassesObject}
            title={
                <GeneralInfoExpansionPanelTitle
                    subject={Tr("order_documents")}
                    unreadElements={unreadDemandDocuments}
                    toggleThread={() => setExpanded(x => !x)}
                    expanded={expanded}
                />
            }
            expanded={expanded}
            onChange={(e, isExpanded) => setExpanded(isExpanded)}

        >
            {
                !generalInfoDocuments ?
                    <Loading/>
                    :
                    <GeneralInfoDocumentsFileTable demandId={demandId} stageId={stageId} supplierId={purchaserOfferContext?.supplierId} generalInfoDocuments={generalInfoDocuments}/>
            }
        </ExpansionPanel>
    )
}

GeneralInfoDocuments.propTypes = {}

export default connect((state) => ({
    generalInfoDocuments: state.resources[DemandOffersGeneralInfoService.GENERAL_INFO_DOCUMENTS],
    demandStageSectionsList: state.resources[DemandOffersService.DEMAND_STAGE_SECTIONS_LIST]
}), {})(withRouter(GeneralInfoDocuments));